// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview10BindJs from "./DragPreview10.bind.js";

var make = DragPreview10BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
